import i18next  from 'i18next';

import es from './es';
import pt from './pt';
import en from './en';

i18next.addResourceBundle('es', 'boatsServicesSearchbox', es);
i18next.addResourceBundle('en', 'boatsServicesSearchbox', en);
i18next.addResourceBundle('pt', 'boatsServicesSearchbox', pt);